import React from 'react'
import SpatialIndex, { SpatialIndexShowcase } from '../Views/Home/SpatialIndex'
import FeatureArtwork from '../Views/Home/FeatureArtwork'
import FeatureSteps from '../Views/Home/FeatureSteps'
import { addCTAs } from '../Components/Links'
import ReactGA from 'react-ga'

const map = [
  {
    key: 'spatialIndex',
    component: SpatialIndex,
    color: 'DARK',
    main: {
      h: [
        'FOAM ',
        <span key="map-spatialIndex-main-h-span1" style={{ color: '#2F80ED' }}>
          Map
        </span>
      ],
      p: [
        'A community-verified registry of',
        <br key="map-spatialIndex-main-p-br1" />,
        ' crowdsourced places.'
      ],
      cta: [
        {
          path: 'https://map.foam.space',
          text: 'Start Mapping',
          type: 'EXTERNAL',
          onClickHandler: () =>
            ReactGA.event({
              category: 'cta_click',
              action: 'start_mapping'
            })
        }
      ],
      justification: 'LEFT',
      width: 'WIDE'
    },
    indexStats: {}
  },
  {
    key: 'featureArtwork',
    component: FeatureArtwork,
    color: 'DARK',
    main: [
      {
        h: [
          'Open to cartographers',
          <br key="map-featureArtwork-main1-h-br1" />,
          'everywhere.'
        ],
        p: [
          'Anyone can add places to the FOAM Map and share their knowledge of the world.',
          <br key="map-featureArtwork-main1-p-br1" />,
          <br key="map-featureArtwork-main1-p-br2" />,
          'Because maps get better when they’re shaped by cartographers like you.',
          <br key="map-featureArtwork-main1-p-br3" />,
          <br key="map-featureArtwork-main1-p-br4" />,
          'Collect locations – called points of interest or POIs – and contribute to an open source registry.'
        ],
        img: (
          <div className="FeatureArtwork-itemContentArtworkWrapper">
            <img
              style={{ width: '100%' }}
              src="/publicAssets/map-page-artwork1.png"
              alt=""
            />
          </div>
        )
      },
      {
        h: [
          'Community verification for ',
          <br key="map-featureArtwork-main2-h-br1" />,
          'crowdsourced places.'
        ],
        p: [
          'A new place must go through multiple stages before it is verified. ',
          <br key="map-featureArtwork-main2-p-br1" />,
          <br key="map-featureArtwork-main2-p-br2" />,
          'Cartographers challenge when they find something that seems false or incorrect, starting a process in which the community votes to decide if a location should be included or removed.  '
        ],
        img: (
          <div className="FeatureArtwork-itemContentArtworkWrapper">
            <img
              style={{ width: '100%' }}
              src="/publicAssets/map-page-artwork2.png"
              alt=""
            />
          </div>
        )
      },
      {
        h: [
          'Building a map that',
          <br key="map-featureArtwork-main3-h-br1" />,
          'can be trusted.'
        ],
        p: [
          'Cartographers use FOAM tokens to sort places and ensure location data is correct and up to date. ',
          <br key="map-featureArtwork-main3-p-br1" />,
          <br key="map-featureArtwork-main3-p-br2" />,
          'Since the tokens have value, spamming has a cost and participants share the value they create. ',
          <br key="map-featureArtwork-main3-p-br3" />,
          <br key="map-featureArtwork-main3-p-br4" />,
          'Tokens enable people to agree on which locations should be included in the FOAM Map without the need for a central authority.'
        ],
        img: (
          <div className="FeatureArtwork-itemContentArtworkWrapper">
            <img
              style={{ width: '100%' }}
              src="/publicAssets/map-page-artwork3.png"
              alt=""
            />
          </div>
        )
      }
    ]
  },
  {
    key: 'featureSteps',
    component: FeatureSteps,
    color: 'DARK',
    shadow: true,
    h: 'How do I become a cartographer?',
    p:
      'This short guide will tell you everything you need to know to start mapping.',
    main: [
      {
        h: 'Browser + Wallet',
        hSub: 'Step 1',
        color: '#2F80ED',
        itemColor: '#196BD9',
        p: [
          'To use the FOAM Map, you need a desktop computer with a compatible browser installed, such as Chrome, Opera or Brave.',
          <br key="map-featureSteps-main1-p-br1" />,
          <br key="map-featureSteps-main1-p-br2" />,
          'Then you need to install a digital wallet like MetaMask. This is a free browser extension that allows you to access digital currencies and tokens.'
        ],
        items: [
          {
            href: 'https://chrome.com',
            name: 'Chrome',
            img: 'publicAssets/icons/logo-Chrome.svg'
          },
          {
            href: 'https://brave.com',
            name: 'Brave',
            img: 'publicAssets/icons/logo-Brave.svg'
          },
          {
            href: 'https://opera.com',
            name: 'Opera',
            img: 'publicAssets/icons/logo-Opera.svg'
          },
          {
            href: 'https://metamask.com',
            name: 'MetaMask',
            img: 'publicAssets/icons/logo-Metamask.svg'
          }
        ]
      },
      {
        h: 'FOAM Token',
        hSub: 'Step 2',
        color: '#27AE60',
        itemColor: '#0B8E42',
        p: [
          'You need FOAM tokens to add and verify locations.',
          <br key="map-featureSteps-main2-p-br1" />,
          <br key="map-featureSteps-main2-p-br2" />,
          'Exchange USD, Bitcoin, Ether or other currencies for FOAM Tokens on the RadarRelay, Poloniex, and Uniswap exchanges.',
          <br key="map-featureSteps-main2-p-br3" />,
          <br key="map-featureSteps-main2-p-br4" />,
          'Once you have FOAM Tokens, make sure they’re in your MetaMask wallet.'
        ],
        items: [
          {
            href: 'https://radarrelay.com',
            name: 'RadarRelay',
            img: 'publicAssets/icons/logo-RadarRelay.svg'
          },
          {
            href: 'https://uniswap.io',
            name: 'Uniswap',
            img: 'publicAssets/icons/logo-Uniswap.svg'
          },
          {
            href: 'https://poloniex.com',
            name: 'Poloniex',
            img: 'publicAssets/icons/logo-Poloniex.svg'
          }
        ]
      },
      {
        h: 'Gas (Ethereum)',
        hSub: 'Step 3',
        color: '#F48068',
        itemColor: '#DB654D',
        p: [
          'The final thing you need is a small amount of Ether (ETH) in your MetaMask wallet to carry out a cartographer’s tasks.',
          <br key="map-featureSteps-main3-p-br1" />,
          <br key="map-featureSteps-main3-p-br2" />,
          'The FOAM Map runs on the Ethereum blockchain to enable a decentralized map. Gas is needed to pay for transactions on the blockchain. ',
          <a
            href="https://mapguide.foam.space/gas"
            target="_blank"
            key="map-featureSteps-main3-p-a1"
            rel="noopener noreferrer"
          >
            Read more
          </a>
        ],
        items: [
          {
            href: 'https://coinbase.com',
            name: 'Coinbase',
            img: 'publicAssets/icons/logo-Coinbase.svg'
          },
          {
            href: 'https://gemini.com',
            name: 'Gemini',
            img: 'publicAssets/icons/logo-Gemini.svg'
          },
          {
            href: 'https://kraken.com',
            name: 'Kraken',
            img: 'publicAssets/icons/logo-Kraken.svg'
          }
        ]
      },
      {
        h: 'Start Mapping!',
        hSub: 'Step 4',
        color: 'transparent',
        itemColor: '',
        p: [
          'That’s everything! Now you’re ready to get started.',
          <br key="map-featureSteps-main4-p-br1" />,
          <br key="map-featureSteps-main4-p-br2" />,
          addCTAs({
            path: 'https://map.foam.space',
            text: 'Go to FOAM Map',
            type: 'EXTERNAL',
            onClickHandler: () =>
              ReactGA.event({
                category: 'cta_click',
                action: 'go_to_foam_map'
              })
          })
        ],
        splash: <SpatialIndexShowcase currentSectionKey={'spatialIndex'} />
      }
    ]
  }
]

export { map }



// WEBPACK FOOTER //
// ./src/content/mapPage.js